import { store } from "@/store";
import { MIGRATION_KEYS } from "@/store/migrations/constant";
import { toggleUseGlobalFilter } from "@/store/slice/datasetSlice";
import { tabStorage } from "@/store/tabStore/storage";

// This File is Handling the migration of LinkedDatasetID from globalFilter state to dataset state.
export const migrateLinkedDatasetIds = async () => {
  // Retrieve and validate linked dataset IDs from storage (per-tab when isolation is on)
  const storedLinkedDatasetIds = await tabStorage.getItem<string[]>(
    MIGRATION_KEYS.LINKED_DATASET_IDS
  );
  const validDatasetIds = storedLinkedDatasetIds?.filter(Boolean) ?? [];
  if (!validDatasetIds.length) return;

  // Validate datasets from store and match with linked dataset IDs
  const { datasets } = store.getState().dataset;
  const allDatasetIds = Object.keys(datasets);
  if (!allDatasetIds.length) return;

  // Match linked dataset IDs with existing datasets in store
  const matchedDataSet = new Set(
    validDatasetIds.filter((id) => id in datasets)
  );
  if (!matchedDataSet.size) return;

  // Dispatch useGlobalFilter for each dataset — true if matched, false otherwise
  allDatasetIds.forEach((datasetId) => {
    store.dispatch(
      toggleUseGlobalFilter({
        datasetId,
        useGlobalFilter: matchedDataSet.has(datasetId)
      })
    );
  });

  // Verify migration and remove linked dataset IDs from localforage
  const { datasets: updatedDatasets } = store.getState().dataset;
  const isCheckValueMigrateLinkedDatasetIDs = allDatasetIds.every(
    (datasetId) =>
      matchedDataSet.has(datasetId)
        ? updatedDatasets[datasetId]?.is_global_admin_area === true
        : updatedDatasets[datasetId]?.is_global_admin_area === false
  );
  if (!isCheckValueMigrateLinkedDatasetIDs) return;

  // Remove linked dataset IDs from storage after successful migration
  await tabStorage.removeItem(MIGRATION_KEYS.LINKED_DATASET_IDS);
};
